/* globals process */

/**
 * Created by rickborst on 14/02/2017.
 */

import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import {routerReducer} from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import * as reducers from './reducers';

let composeEnhancers,
    rootReducer,
    store;

/**
 * Singleton instance of the redux store.
 *
 * @returns {Object} Redux store.
 */
export function getInstance () {

	if (!store) {
        // if (process.env.NODE_ENV === 'development') {

            /* eslint-disable max-len */
            // Redux debugging tools. See// https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd

            /* eslint-disable no-underscore-dangle */
            composeEnhancers = composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;
        // }

        rootReducer = combineReducers({
            ...reducers,
            routing: routerReducer,
            form: formReducer
        });

        store = createStore(rootReducer, composeEnhancers
            ? composeEnhancers(applyMiddleware(thunk))
            : applyMiddleware(thunk));
    }

    store.subscribe(()=>  {
        localStorage.setItem('newRegistration', JSON.stringify(store.getState().newRegistration))
    })

    return store;
}


// WEBPACK FOOTER //
// ./src/js/store/store.js